var _rect, _rect2, _path, _circle, _path2, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntertainment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#ED74ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(14 14)",
    fill: "#ED74ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1606 19.9809C20.9826 20.4316 21.1394 20.9506 21.4791 21.3085C22.2573 22.1282 22.8086 23.4181 22.9588 24.911C22.9859 25.0022 23 25.0979 23 25.1981C23 25.2803 22.9984 25.367 22.9954 25.4579C22.9984 25.5503 23 25.6433 23 25.7368C23 26.3855 22.925 27.0073 22.7876 27.5829C22.4511 30.049 21.8333 33 21.8333 33H17.1667C17.1667 33 16.5489 30.0489 16.2124 27.5828C16.075 27.0072 16 26.3855 16 25.7368C16 25.6433 16.0016 25.5503 16.0046 25.4579C16.0016 25.367 16 25.2803 16 25.1981C16 25.0979 16.0141 25.0022 16.0412 24.911C16.1914 23.4181 16.7427 22.1282 17.5209 21.3085C17.8606 20.9506 18.0174 20.4316 17.8394 19.9809C17.4234 18.9278 17.1667 17.7353 17.1667 17.1474C17.1667 15.9614 18.2113 15 19.5 15C20.7887 15 21.8333 15.9614 21.8333 17.1474C21.8333 17.7353 21.5766 18.9278 21.1606 19.9809Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 6,
    fill: "#ED74ED",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27C27 27.5523 26.5523 28 26 28C25.4477 28 25 27.5523 25 27C25 26.4477 25.4477 26 26 26C26.5523 26 27 26.4477 27 27Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 27,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/Entertainment.4e85c87b972d81d7891b8d5cc956c2eb.svg";
export { ForwardRef as ReactComponent };